import { create } from "zustand";

import pureStore from "./pureStore";

const useMainStore = create(pureStore);

export default useMainStore;
